export const wagerMap = {
  wagerId: 0, masterWagerId: 1, eventName: 2,
  parentEventName: 3, headToHead: 4, wagerNumber: 5,
  wagerNo: 6, wagerDateFm: 7, eventDateFm: 8,
  oddsStr: 9, eventDate: 10, status: 11,
  wagerDate: 12, homeTeam: 13, awayTeam: 14,
  selection: 15, selectionType: 16, handicap: 17,
  odds: 18, oddsFormat: 19, betType: 20,
  league: 21, stake: 22, sportId: 23,
  sport: 24, sportGroup: 25, currencyCode: 26,
  homeFav: 27, awayFav: 28, inplayScore: 29,
  inPlay: 30, homePitcher: 31, awayPitcher: 32,
  homePitcherName: 33, awayPitcherName: 34, period: 35,
  cancellationStatus: 36, wagerSelections: 37, category: 38,
  unit: 39, winRiskStake: 40, toWin: 41,
  toRisk: 42, product: 43, vsHandicap: 44,
  vsSelection: 45, vsBetType: 46, vsMarketType: 47,
  vsSelectionName: 48, parlayMixOdds: 49, vsLegStatus: 50,
  vsSubType: 51, multiplier: 52, teamType: 53,
  parlayMixOddsStr: 54, vsBetTypeId: 55, vsSubTypeId: 56,
  isMoneyLine: 57, competitors: 58, vsWagerSelections: 59,
  adjOdds: 60, adjOddsStr: 61, betAcceptanceType: 62,
  settlementDate: 63, settlementDateFm: 64, dateFitlerType: 65, 
  relateEventBetType: 66, raceNumber: 67, trackName: 68, 
  runnerNumber: 69, runnerName: 70, hrBetType: 71, hrMarketType: 72, raceDateFm: 76,
  gradingUnit: 77, isRjectedClosedEvent: 82, originalHomeTeam: 84
};

export const wagerSelectionMap = {
  selection: 0, homeFav: 1, awayFav: 2,
  eventDateFm: 3, oddsStr: 4, scores: 5,
  sportId: 6, sport: 7, sportGroup: 8,
  league: 9, homeTeam: 10, awayTeam: 11,
  betType: 12, eventDate: 13, wagerId: 14,
  selectionType: 15, inplayScore: 16, inPlay: 17,
  odds: 18, handicap: 19, homePitcher: 20,
  awayPitcher: 21, homePitcherName: 22, awayPitcherName: 23,
  period: 24, eventResult: 25, legStatus: 26,
  teamType: 27, eventName: 28, point: 29,
  type: 30, altTeaser: 31, adjOdds: 32,
  adjOddsStr: 33, raceNumber: 34, trackName: 35,
  runnerNumber: 36, runnerName: 37, hrBetType: 38, hrMarketType: 39,
  trackCountry: 40, deductions: 41, scratchedName: 42, raceDateFm: 43,
  gradingUnit: 44, eventId: 45, betAcceptanceType: 47
}

export const vsWagerSelectionMap = {
  handicap: 0, selection: 1, betType: 2, vsHandicap: 3, 
  sportId: 4, sport: 5, competitors: 6, homeFav: 7, 
  awayFav: 8, homeTeam: 9, awayTeam: 10, vsMarketType: 11, 
  eventDateFm: 12, odds: 13, oddsFormat: 14, oddsStr: 15, 
  eventName: 16, vsLegStatus: 17, isMoneyLine: 18, vsSubType: 19
}

export const PAGE_TYPE = {
  PENDING: 'PENDING',
  GRADED: 'GRADED',
}

export const eventScoreMap = {
  period: 0,
  score: 1,
}


// WEBPACK FOOTER //
// ./src/app/components/CompactView/LeftSideBarComponent/PendingBetsComponent/constants.js